/**
 * `?ui=workspace` also chooses the workspace version of a screen that has one (pages/shared/
 * workspaceUi.ts). While it is on the address, keep it on every move through the shell, so the
 * person comparing a pilot screen with its original is not flipped back by the first click.
 */
export function keepWorkspaceUi(path: string, search: string): string {
  if (new URLSearchParams(search).get('ui') !== 'workspace') return path;
  const [pathname = '', query = ''] = path.split('?');
  const params = new URLSearchParams(query);
  params.set('ui', 'workspace');
  return `${pathname}?${params.toString()}`;
}
